"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ListItem_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/List/ListItem"));
var ListContent_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/List/ListContent"));
var ListHeader_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/List/ListHeader"));
var ListDescription_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/List/ListDescription"));
var genIcon_1 = __importDefault(require("../../../utils/genIcon"));
/**
 * Each list item in a FormattedList component should be contained in a child Item component.
 */
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genContent = function () {
            var content = _this.props.content;
            if (content) {
                return React.createElement(ListDescription_1.default, null, content);
            }
            return null;
        };
        _this.genImage = function () {
            var _a = _this.props, imageUrl = _a.imageUrl, descriptiveIconName = _a.descriptiveIconName;
            if (imageUrl && !descriptiveIconName) {
                return (React.createElement("div", { className: "column-flex" },
                    React.createElement("div", { className: "item-image", style: { backgroundImage: "url(" + imageUrl + ")" } })));
            }
            return null;
        };
        _this.genClasses = function () {
            var _a = _this.props, className = _a.className, onClick = _a.onClick, content = _a.content;
            var classes = 'scuf-listitem-wrapper';
            classes += onClick ? ' onclick interactive' : '';
            classes += className ? ' ' + className : '';
            classes += content ? '' : ' no-content';
            return classes;
        };
        _this.genTimeStamp = function () {
            var timeStamp = _this.props.timeStamp;
            if (timeStamp) {
                return (React.createElement("div", { className: "content time-container" },
                    React.createElement("div", { className: "time-stamp" }, timeStamp)));
            }
            return null;
        };
        return _this;
    }
    Item.prototype.render = function () {
        var _a = this.props, className = _a.className, onClick = _a.onClick, title = _a.title, actionIconName = _a.actionIconName, actionIconRoot = _a.actionIconRoot, content = _a.content, descriptiveIconName = _a.descriptiveIconName, descriptiveIconRoot = _a.descriptiveIconRoot, imageUrl = _a.imageUrl, timeStamp = _a.timeStamp, rest = __rest(_a, ["className", "onClick", "title", "actionIconName", "actionIconRoot", "content", "descriptiveIconName", "descriptiveIconRoot", "imageUrl", "timeStamp"]);
        return (React.createElement("div", __assign({}, rest, { className: this.genClasses() }),
            React.createElement(ListItem_1.default, { onClick: onClick },
                this.genImage(),
                descriptiveIconName && genIcon_1.default(descriptiveIconName, {
                    root: descriptiveIconRoot,
                    className: 'descriptive-icon'
                }),
                React.createElement(ListContent_1.default, { className: "column-flex" },
                    React.createElement(ListHeader_1.default, null, title),
                    this.genContent()),
                actionIconName && genIcon_1.default(actionIconName, {
                    root: actionIconRoot,
                    className: 'action-icon'
                }),
                this.genTimeStamp())));
    };
    Item.defaultProps = {
        descriptiveIconRoot: 'common',
        actionIconRoot: 'common'
    };
    return Item;
}(React.Component));
exports.default = Item;
